// Who a bank account is titled to. Values mirror CertifID.V2.CompanyService.Common.Enums.AccountHolderType
// (1-based so a stray backend default(0) never reads as Individual). Absent = pre-PLAT-3157 record.
export enum AccountHolderType {
    Individual = 1,
    Business = 2,
}

export const ACCOUNT_HOLDER_TYPE_OPTIONS: { value: AccountHolderType; display: string; description: string }[] = [
    { value: AccountHolderType.Individual, display: 'Individual', description: 'The bank account is owned by a person.' },
    { value: AccountHolderType.Business, display: 'Business', description: 'The bank account is owned by a company, trust, or other entity.' },
];
